import React from "react";
import { useOutletContext } from "react-router-dom";
import DashboardSub from "../../components/Company/SettingsSub/DashboardSub";

const CompanyDashboardSub = () => {
  const { page, setIsLoading, setPage, setIsModalOpen } = useOutletContext();

  return (
    <DashboardSub
      page={page} 
      setIsLoading={setIsLoading} 
      setPage={setPage} 
      setIsModalOpen={setIsModalOpen}
    />
  );
};

export default CompanyDashboardSub;